import React from 'react';
import ReactDOM from 'react-dom';

import App from './App.js';
import { clearViewState } from './utils/ProgramSummaryViewState.js';
import './index.css';

// A full page load/refresh re-runs this bundle; SPA navigation does not. Clear the
// saved Program Summary view here so filters/sort/tab reset on refresh but survive
// in-app drill-in/return.
clearViewState();

ReactDOM.render(<App />, document.getElementById('root'));
